import { render, staticRenderFns } from "./addManufacturer.vue?vue&type=template&id=0188ebec&scoped=true"
import script from "./addManufacturer.vue?vue&type=script&lang=js"
export * from "./addManufacturer.vue?vue&type=script&lang=js"
import style0 from "./addManufacturer.vue?vue&type=style&index=0&id=0188ebec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0188ebec",
  null
  
)

export default component.exports